let showErrorHandler = null;
let showRegisterHandler = null;

export function bindMessageDialogHandlers({ showError, showRegister } = {}) {
  if (showError !== undefined) showErrorHandler = showError;
  if (showRegister !== undefined) showRegisterHandler = showRegister;
}

export function showAppError(message, title = 'Error') {
  if (!message) return;
  showErrorHandler?.(message, title);
}

export function showRegisterAppDialog() {
  showRegisterHandler?.();
}
